<template>
  <span class="sec-timer"> {{ duration }}s</span>
</template>

<script>
export default {
    data(){
        return {
            duration: 30,
            interval: null,
        }
    },
    mounted(){
        this.interval = setInterval(() => {
            --this.duration
        }, 1000)
    },
    beforeDestroy(){
        clearInterval(this.interval)
    }
}
</script>

<style>
.sec-timer {
    color: #50C6DF;;
    font-weight: bold;
}
</style>